const mustBeCool = {
    $validator: (value) => {
        let regex = RegExp('^[a-z]([-\']?[a-z]+)*( [a-z]([-\']?[a-z]+)*)+$');
        return regex.test(value);
    },
   // $message: 'test cool'
};

export default mustBeCool
